import { useLocation } from "react-router-dom";
import { useRecordNavigation } from "@jkast90/kast-common/diagnostics/react";

/** Records each screen for bug reports. */
export default function RouteTracker() {
  useRecordNavigation(useLocation().pathname);
  return null;
}
